/* Sunday & Pine — theme scripts (no dependencies) */
(function () {
  'use strict';

  var SP = window.SP || (window.SP = {});
  SP.routes = SP.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function onReady(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- Money ---------------- */
  SP.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || SP.moneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      n = (Number(n) / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  /* ---------------- Placeholder art (used until real products/images are added) ---------------- */
  var PALETTES = [
    ['#efe6d8', '#d9c9b0'], ['#e3e8e1', '#c3cfc3'], ['#f1e4df', '#dcc2b9'],
    ['#e8e2d6', '#cbbfa8'], ['#1f3a2e', '#0f2219'], ['#ece6dd', '#d6cab8']
  ];
  var ART = {
    candle: function () { return '<rect x="140" y="230" width="120" height="150" rx="16" fill="#f7f1e6" stroke="#cdb98f" stroke-width="3"/><rect x="140" y="230" width="120" height="28" rx="12" fill="#e9dcc3"/><rect x="152" y="300" width="96" height="40" rx="4" fill="none" stroke="#b8955a" stroke-width="2"/><line x1="200" y1="230" x2="200" y2="212" stroke="#3a2f22" stroke-width="3"/><ellipse cx="200" cy="196" rx="38" ry="38" fill="#ffd98a" opacity=".25"/><path d="M200 172 C 214 192, 210 210, 200 212 C 190 210, 186 192, 200 172 Z" fill="#f5b544"/>'; },
    vase: function () { return '<path d="M168 200 C 150 260, 130 300, 150 360 C 160 386, 240 386, 250 360 C 270 300, 250 260, 232 200 Z" fill="#f4efe6" stroke="#cbbd9f" stroke-width="3"/><path d="M200 200 C 190 150, 160 120, 140 100 M200 200 C 205 140, 230 110, 262 96 M200 200 C 200 160, 200 130, 204 90" stroke="#5c7a5f" stroke-width="3" fill="none"/><circle cx="140" cy="100" r="10" fill="#e6d0a2"/><circle cx="262" cy="96" r="12" fill="#e6d0a2"/><circle cx="204" cy="88" r="9" fill="#f2e3c4"/>'; },
    throw: function () { return '<rect x="110" y="300" width="180" height="56" rx="14" fill="#c9b79a"/><rect x="104" y="250" width="192" height="56" rx="14" fill="#e8dcc6"/><rect x="116" y="200" width="168" height="54" rx="14" fill="#a8b8a6"/>' + (function () { var s = ''; for (var i = 0; i < 9; i++) { s += '<line x1="' + (124 + i * 18) + '" y1="356" x2="' + (124 + i * 18) + '" y2="372" stroke="#c9b79a" stroke-width="3"/>'; } return s; })(); },
    ornament: function () { return '<line x1="200" y1="90" x2="200" y2="168" stroke="#b8955a" stroke-width="2"/><rect x="184" y="160" width="32" height="20" rx="4" fill="#c9a865"/><circle cx="200" cy="262" r="88" fill="url(#o)"/><ellipse cx="170" cy="228" rx="22" ry="14" fill="#fff" opacity=".45"/><path d="M118 262 Q 200 296 282 262" stroke="#e6d0a2" stroke-width="3" fill="none" opacity=".7"/><defs><radialGradient id="o" cx=".4" cy=".35"><stop offset="0" stop-color="#c24a5b"/><stop offset="1" stop-color="#4c0c16"/></radialGradient></defs>'; },
    gift: function () { return '<rect x="120" y="230" width="160" height="140" rx="6" fill="#1f3a2e"/><rect x="110" y="206" width="180" height="36" rx="6" fill="#28493a"/><rect x="188" y="206" width="24" height="164" fill="#b8955a"/><path d="M200 206 C 170 160, 130 170, 150 200 Z M200 206 C 230 160, 270 170, 250 200 Z" fill="#c9a865"/><circle cx="200" cy="204" r="10" fill="#e6d0a2"/>'; },
    lamp: function () { return '<ellipse cx="200" cy="170" rx="90" ry="70" fill="#fff4dc" opacity=".55"/><path d="M150 130 L250 130 L276 210 L124 210 Z" fill="#f5ecdc" stroke="#cbbd9f" stroke-width="3"/><rect x="194" y="210" width="12" height="130" fill="#b8955a"/><ellipse cx="200" cy="350" rx="56" ry="14" fill="#8e7444"/>'; },
    wreath: function () { var s = '<circle cx="200" cy="240" r="96" fill="none" stroke="#2f5240" stroke-width="40"/>'; for (var i = 0; i < 16; i++) { var a = i / 16 * Math.PI * 2; s += '<circle cx="' + (200 + Math.cos(a) * 96).toFixed(1) + '" cy="' + (240 + Math.sin(a) * 96).toFixed(1) + '" r="' + (i % 3 ? 5 : 8) + '" fill="' + (i % 3 ? '#e6d0a2' : '#a3283a') + '"/>'; } return s + '<path d="M200 150 C 176 120, 150 132, 164 152 Z M200 150 C 224 120, 250 132, 236 152 Z" fill="#8e1f2f"/><path d="M196 152 L184 196 M204 152 L216 196" stroke="#8e1f2f" stroke-width="7"/>'; },
    diffuser: function () { return '<path d="M168 250 L232 250 L244 370 L156 370 Z" fill="#d7e1d6" stroke="#9fb3a1" stroke-width="3" opacity=".9"/><rect x="186" y="226" width="28" height="26" rx="4" fill="#b8955a"/><path d="M196 228 L150 100 M200 228 L196 92 M204 228 L246 104 M200 228 L226 96 M198 228 L170 96" stroke="#3a2f22" stroke-width="2.5"/>'; },
    pillow: function () { return '<path d="M110 180 Q 200 160 290 180 Q 310 270 290 360 Q 200 380 110 360 Q 90 270 110 180 Z" fill="#f3ede2" stroke="#d6c8b0" stroke-width="3"/>' + (function () { var s = ''; for (var y = 200; y < 350; y += 14) for (var x = 130; x < 280; x += 14) s += '<circle cx="' + x + '" cy="' + y + '" r="3" fill="#e1d6c2"/>'; return s; })(); },
    tray: function () { return '<ellipse cx="200" cy="320" rx="140" ry="44" fill="#d9cfc0" stroke="#bfb19a" stroke-width="3"/><ellipse cx="200" cy="312" rx="122" ry="34" fill="#e8e0d3"/><rect x="150" y="250" width="40" height="62" rx="8" fill="#f7f1e6" stroke="#cdb98f" stroke-width="2"/><circle cx="240" cy="292" r="22" fill="#b8955a"/>'; },
    mirror: function () { return '<path d="M130 380 L130 200 A70 70 0 0 1 270 200 L270 380 Z" fill="#dfe6e3" stroke="#b8955a" stroke-width="8"/><path d="M160 220 L200 170 M180 260 L240 190" stroke="#fff" stroke-width="6" opacity=".6"/>'; },
    mug: function () { return '<rect x="140" y="220" width="110" height="130" rx="18" fill="#f3ede2" stroke="#cbbd9f" stroke-width="3"/><path d="M250 250 C 290 250, 290 320, 250 320" stroke="#cbbd9f" stroke-width="12" fill="none"/><path d="M175 200 C 165 180, 190 170, 180 150 M205 200 C 195 180, 220 170, 210 150" stroke="#cbbd9f" stroke-width="4" fill="none" opacity=".7"/>'; },
    room: function () { return '<rect x="0" y="330" width="400" height="170" fill="rgba(0,0,0,.08)"/><rect x="70" y="250" width="260" height="70" rx="20" fill="#c9b79a"/><rect x="80" y="210" width="240" height="60" rx="20" fill="#e3d6c1"/><rect x="60" y="300" width="20" height="40" fill="#8e7444"/><rect x="320" y="300" width="20" height="40" fill="#8e7444"/><path d="M200 60 L200 120" stroke="#b8955a" stroke-width="2"/><ellipse cx="200" cy="140" rx="40" ry="22" fill="#f5ecdc"/><rect x="250" y="120" width="60" height="70" rx="4" fill="none" stroke="#b8955a" stroke-width="4"/>'; }
  };
  SP.art = function (type, idx) {
    var pal = PALETTES[(idx || 0) % PALETTES.length];
    if (type === 'gift' || type === 'wreath' || type === 'ornament') pal = idx % 2 ? ['#efe6d8', '#d9c9b0'] : ['#f1e4df', '#dcc2b9'];
    var draw = ART[type] || ART.vase;
    return '<svg class="sp-art" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<defs><linearGradient id="bg' + idx + type + '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + pal[0] + '"/><stop offset="1" stop-color="' + pal[1] + '"/></linearGradient></defs>' +
      '<rect width="400" height="500" fill="url(#bg' + idx + type + ')"/><ellipse cx="200" cy="384" rx="120" ry="16" fill="rgba(0,0,0,.12)"/>' + draw() + '</svg>';
  };
  function fillArt(root) {
    $$('[data-sp-art]', root).forEach(function (el, i) {
      if (el.dataset.artDone) return;
      el.dataset.artDone = '1';
      el.insertAdjacentHTML('afterbegin', SP.art(el.getAttribute('data-sp-art'), Number(el.getAttribute('data-art-index') || i)));
    });
  }

  /* ---------------- Ribbon intro ---------------- */
  function initIntro() {
    var intro = document.getElementById('sp-intro');
    var root = document.documentElement;
    if (!intro) { root.classList.remove('sp-intro-active'); return; }
    var finished = false;
    var timers = [];
    function finish() {
      if (finished) return;
      finished = true;
      timers.forEach(clearTimeout);
      root.classList.remove('sp-intro-active', 'sp-intro-revealing');
      if (intro.parentNode) intro.parentNode.removeChild(intro);
      document.dispatchEvent(new CustomEvent('sp:intro-done'));
    }
    function play() {
      try { if (intro.getAttribute('data-once') === 'true') sessionStorage.setItem('sp-intro-seen', '1'); } catch (e) {}
      intro.classList.add('is-open');
      if (reduceMotion) { root.classList.add('sp-intro-revealing'); timers.push(setTimeout(finish, 550)); return; }
      timers.push(setTimeout(function () { root.classList.add('sp-intro-revealing'); }, 950));
      timers.push(setTimeout(finish, 2600));
    }
    var skip = intro.querySelector('[data-intro-skip]');
    if (skip) skip.addEventListener('click', function () {
      intro.style.transition = 'opacity .35s'; intro.style.opacity = '0';
      root.classList.add('sp-intro-revealing');
      setTimeout(finish, 380);
    });
    // Start once the page has painted (and fonts are ready, if possible) so the reveal is seamless.
    var started = false;
    function start() { if (started) return; started = true; setTimeout(play, 650); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
    window.addEventListener('load', start);
    setTimeout(start, 2200); // safety net
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var body = document.body;
    if (header.classList.contains('is-transparent')) body.classList.add('has-transparent-header');
    function setH() { document.documentElement.style.setProperty('--sp-header-h', header.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH);
    if (window.ResizeObserver) new ResizeObserver(setH).observe(header);

    var lastY = 0;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      header.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !document.querySelector('.sp-drawer.is-open'));
      if (y < lastY - 4) header.classList.remove('is-hidden');
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Announcement rotation
    var items = $$('.sp-announce__item', header);
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    }

    // Overlays
    function bindOverlay(openSel, panelSel) {
      var panel = $(panelSel);
      if (!panel) return;
      $$(openSel).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          panel.classList.add('is-open');
          var input = panel.querySelector('input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 300);
        });
      });
      $$('[data-close]', panel).forEach(function (el) { el.addEventListener('click', function () { panel.classList.remove('is-open'); }); });
    }
    bindOverlay('[data-menu-open]', '.sp-mmenu');
    bindOverlay('[data-search-open]', '.sp-search');
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.sp-mmenu.is-open, .sp-search.is-open, .sp-drawer.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    });
  }

  /* ---------------- Snow ---------------- */
  function initSnow() {
    $$('[data-snow]').forEach(function (canvas) {
      if (canvas.dataset.bound) return; canvas.dataset.bound = '1';
      var ctx = canvas.getContext('2d');
      var density = Number(canvas.getAttribute('data-density') || 6);
      var flakes = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var wind = 0, targetWind = 0, running = true, t = 0;
      function resize() {
        var r = canvas.getBoundingClientRect();
        w = r.width; h = r.height;
        canvas.width = w * dpr; canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var count = Math.round((w * h) / 12000 * density / 6 * 10);
        count = Math.min(count, 420);
        flakes = [];
        for (var i = 0; i < count; i++) flakes.push(make(true));
      }
      function make(anywhere) {
        var depth = Math.random();
        return {
          x: Math.random() * w,
          y: anywhere ? Math.random() * h : -10,
          r: 0.6 + depth * depth * 3.2,
          vy: 0.25 + depth * 1.1,
          sway: Math.random() * Math.PI * 2,
          swaySpeed: 0.004 + Math.random() * 0.012,
          a: 0.35 + depth * 0.6,
          depth: depth
        };
      }
      function draw() {
        ctx.clearRect(0, 0, w, h);
        wind += (targetWind - wind) * 0.02;
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.sway += f.swaySpeed;
          f.y += f.vy;
          f.x += Math.sin(f.sway) * 0.4 + wind * (0.3 + f.depth);
          if (f.y > h + 10) { flakes[i] = make(false); continue; }
          if (f.x > w + 10) f.x = -10; else if (f.x < -10) f.x = w + 10;
          ctx.beginPath();
          if (f.r > 2.4) {
            var g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 1.8);
            g.addColorStop(0, 'rgba(255,255,255,' + f.a + ')');
            g.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.fillStyle = g;
            ctx.arc(f.x, f.y, f.r * 1.8, 0, Math.PI * 2);
          } else {
            ctx.fillStyle = 'rgba(255,255,255,' + f.a + ')';
            ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          }
          ctx.fill();
        }
        t++;
      }
      function loop() { if (running) draw(); requestAnimationFrame(loop); }
      resize();
      window.addEventListener('resize', resize);
      var host = canvas.parentElement;
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        targetWind = ((e.clientX - r.left) / r.width - 0.5) * 2.2;
      });
      host.addEventListener('pointerleave', function () { targetWind = 0; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { running = en[0].isIntersecting; }).observe(canvas);
      }
      if (reduceMotion) { draw(); return; }
      loop();
    });
  }

  /* ---------------- Countdown ---------------- */
  function parseTarget(str) {
    var now = new Date();
    if (str) {
      var m = String(str).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (m) return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    }
    var xmas = new Date(now.getFullYear(), 11, 25);
    if (now > new Date(now.getFullYear(), 11, 26)) xmas = new Date(now.getFullYear() + 1, 11, 25);
    return xmas;
  }
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var target = parseTarget(el.getAttribute('data-countdown'));
      var parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
      var prev = {};
      function set(key, val) {
        var node = parts[key]; if (!node) return;
        var txt = String(val).padStart(2, '0');
        if (prev[key] !== txt) {
          node.textContent = txt;
          if (prev[key] !== undefined && !reduceMotion) { node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); }
          prev[key] = txt;
        }
      }
      function tick() {
        var diff = target - new Date();
        if (diff <= 0) {
          var grid = $('.sp-countdown__grid', el);
          if (grid) grid.innerHTML = '<span class="sp-countdown__done">' + esc(el.getAttribute('data-done') || 'Merry Christmas') + '</span>';
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        set('d', Math.floor(s / 86400));
        set('h', Math.floor((s % 86400) / 3600));
        set('m', Math.floor((s % 3600) / 60));
        set('s', s % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------------- 3D product ring ---------------- */
  function initRing() {
    $$('[data-ring-stage]').forEach(function (stage) {
      if (stage.dataset.bound) return; stage.dataset.bound = '1';
      var ring = $('.sp-ring', stage);
      var items = $$('.sp-ring__item', ring);
      var n = items.length;
      if (!n) return;
      var angle = 0, velocity = reduceMotion ? 0 : -0.12, dragging = false, lastX = 0, hovered = false, radius = 300;
      var autoSpeed = reduceMotion ? 0 : -0.12;

      function layout() {
        var cardW = items[0].offsetWidth || 230;
        if (n === 1) radius = 0;
        else if (n === 2) radius = cardW * 0.75;
        else radius = Math.max(cardW * 0.62 / Math.tan(Math.PI / n), cardW * 1.05);
        var maxR = stage.offsetWidth * 0.62;
        radius = Math.min(radius, maxR);
      }
      function render() {
        var step = 360 / n;
        var frontIdx = 0, best = -2;
        items.forEach(function (it, i) {
          var a = angle + i * step;
          var rad = a * Math.PI / 180;
          var c = Math.cos(rad); // 1 = front
          var y = Math.sin((a + 90) * Math.PI / 90) * 6;
          it.style.transform = 'rotateY(' + a + 'deg) translateZ(' + radius + 'px) rotateY(' + (-a + Math.sin(rad) * 28) + 'deg) translateY(' + y + 'px)';
          it.style.opacity = (0.35 + (c + 1) / 2 * 0.65).toFixed(3);
          it.style.filter = 'blur(' + Math.max(0, (1 - c) * 1.1).toFixed(2) + 'px) brightness(' + (0.6 + (c + 1) / 2 * 0.4).toFixed(3) + ')';
          it.style.zIndex = Math.round((c + 1) * 100);
          it.style.pointerEvents = c > 0.3 ? 'auto' : 'none';
          if (c > best) { best = c; frontIdx = i; }
        });
        items.forEach(function (it, i) { it.classList.toggle('is-front', i === frontIdx); });
      }
      function loop() {
        if (!dragging) {
          var target = hovered ? 0 : autoSpeed;
          velocity += (target - velocity) * 0.04;
          angle += velocity;
        }
        render();
        requestAnimationFrame(loop);
      }
      stage.addEventListener('pointerenter', function () { hovered = true; });
      stage.addEventListener('pointerleave', function () { hovered = false; dragging = false; });
      stage.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; velocity = 0; });
      window.addEventListener('pointerup', function () { dragging = false; });
      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lastX; lastX = e.clientX;
        angle += dx * 0.35; velocity = dx * 0.35;
      });
      // Prevent click-through when the user was dragging
      var downX = 0;
      stage.addEventListener('pointerdown', function (e) { downX = e.clientX; }, true);
      stage.addEventListener('click', function (e) { if (Math.abs(e.clientX - downX) > 6) e.preventDefault(); }, true);
      layout();
      window.addEventListener('resize', layout);
      render();
      if (reduceMotion) return;
      loop();
    });
  }

  /* ---------------- Parallax ornaments ---------------- */
  function initParallax() {
    $$('[data-parallax-root]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var host = root.closest('section') || root.parentElement;
      var els = $$('[data-depth]', root);
      if (!finePointer || reduceMotion) return;
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        els.forEach(function (el) {
          var d = Number(el.getAttribute('data-depth'));
          el.style.setProperty('--px', (-x * d * 60).toFixed(1) + 'px');
          el.style.setProperty('--py', (-y * d * 40).toFixed(1) + 'px');
        });
      });
    });
    // Scroll parallax for story images
    var pars = $$('[data-scroll-parallax]');
    if (pars.length && !reduceMotion) {
      var onScroll = function () {
        pars.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          el.style.setProperty('--par', (p * -40).toFixed(1) + 'px');
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------------- 3D tilt ---------------- */
  function initTilt(root) {
    if (!finePointer || reduceMotion || !document.body.classList.contains('sp-tilt-on')) return;
    $$('[data-tilt]', root).forEach(function (card) {
      if (card.dataset.tiltBound) return;
      card.dataset.tiltBound = '1';
      var target = card.querySelector('[data-tilt-target]') || card;
      var max = Number(card.getAttribute('data-tilt') || 8);
      card.addEventListener('pointermove', function (e) {
        var r = target.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        target.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        target.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        target.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        target.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        target.style.setProperty('--rx', '0deg');
        target.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(root) {
    var els = $$('[data-reveal]', root);
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- Horizontal scrollers ---------------- */
  function initScrollers() {
    $$('[data-scroller]').forEach(function (wrap) {
      if (wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var track = $('[data-scroller-track]', wrap);
      if (!track) return;
      $$('[data-scroll-dir]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-scroll-dir'));
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------------- Cart ---------------- */
  var Cart = SP.Cart = {
    drawer: null,
    open: function () { if (this.drawer) { this.drawer.classList.add('is-open'); } },
    close: function () { if (this.drawer) this.drawer.classList.remove('is-open'); },
    fetch: function () {
      return fetch(SP.routes.root.replace(/\/?$/, '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (body) {
      var opts = { method: 'POST', headers: { Accept: 'application/json' } };
      if (body instanceof FormData) opts.body = body;
      else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
      return fetch(SP.routes.cartAdd + '.js', opts).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw data; return data; });
      }).then(function () { return Cart.refresh(true); });
    },
    change: function (key, qty) {
      return fetch(SP.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; });
    },
    refresh: function (openAfter) {
      return Cart.fetch().then(function (cart) { Cart.render(cart); if (openAfter) Cart.open(); return cart; });
    },
    render: function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
      var d = this.drawer; if (!d) return;
      var list = $('[data-cart-items]', d), foot = $('[data-cart-foot]', d), total = $('[data-cart-total]', d);
      var ship = $('[data-ship]', d);
      if (ship) {
        var th = Number(SP.freeShippingThreshold || 0);
        if (!th) ship.hidden = true;
        else {
          ship.hidden = false;
          var left = th - cart.total_price;
          $('[data-ship-text]', ship).innerHTML = left > 0 ? 'You are <strong>' + SP.formatMoney(left) + '</strong> away from complimentary shipping' : 'You’ve unlocked <strong>complimentary shipping</strong>';
          $('[data-ship-fill]', ship).style.width = Math.min(100, cart.total_price / th * 100) + '%';
        }
      }
      if (!cart.item_count) {
        list.innerHTML = '<div class="sp-drawer__empty"><p>Your bag is empty</p><a class="sp-btn" href="' + SP.routes.root.replace(/\/?$/, '/') + 'collections/all">Explore the collection</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      if (total) total.textContent = SP.formatMoney(cart.total_price);
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sp-line__variant">' + esc(it.variant_title) + '</div>' : '';
        return '<div class="sp-line">' +
          '<a class="sp-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
          '<div><a class="sp-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="sp-qty"><button type="button" aria-label="Decrease" data-qty-change="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '">&minus;</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-qty-change="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '">+</button></div>' +
          '<div><button type="button" class="sp-line__remove" data-qty-change="' + esc(it.key) + '" data-qty="0">Remove</button></div></div>' +
          '<div class="sp-line__price">' + SP.formatMoney(it.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    },
    init: function () {
      this.drawer = $('.sp-drawer');
      var self = this;
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { if (!self.drawer) return; e.preventDefault(); self.refresh(true); });
      });
      if (this.drawer) {
        $$('[data-close]', this.drawer).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
        this.drawer.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-qty-change]');
          if (!btn) return;
          btn.disabled = true;
          self.change(btn.getAttribute('data-qty-change'), Number(btn.getAttribute('data-qty')));
        });
      }
      document.addEventListener('click', function (e) {
        var q = e.target.closest('[data-quick-add]');
        if (!q) return;
        e.preventDefault();
        var id = q.getAttribute('data-quick-add');
        if (!id) return;
        var label = q.innerHTML;
        q.innerHTML = 'Adding…';
        self.add({ items: [{ id: Number(id), quantity: 1 }] }).catch(function (err) {
          alert((err && (err.description || err.message)) || 'Sorry, this item could not be added.');
        }).then(function () { q.innerHTML = label; });
      });
    }
  };

  /* ---------------- Product page ---------------- */
  function initProduct() {
    $$('[data-product-section]').forEach(function (section) {
      var jsonEl = $('[data-product-json]', section);
      var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      var form = $('form.sp-pform', section);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = $('[data-add-btn]', section);
      var priceEl = $('[data-price]', section);

      // Gallery
      var slides = $$('.sp-gallery__slide', section);
      var thumbs = $$('.sp-gallery__thumb', section);
      function show(mediaId) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-media-id')); }); });
      $$('.sp-gallery__zoom', section).forEach(function (z) {
        if (!finePointer) return;
        z.addEventListener('pointermove', function (e) {
          var r = z.getBoundingClientRect();
          z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
      });

      // Quantity
      $$('[data-qty-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentElement.querySelector('input');
          input.value = Math.max(1, Number(input.value || 1) + Number(b.getAttribute('data-qty-step')));
        });
      });

      // Variants
      function selectedOptions() {
        return $$('[data-option-index]', section).map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function update() {
        if (!product) return;
        var opts = selectedOptions();
        var v = product.variants.find(function (vr) { return vr.options.every(function (o, i) { return o === opts[i]; }); });
        $$('[data-option-index]', section).forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          var lab = fs.querySelector('[data-selected-value]');
          if (lab && c) lab.textContent = c.value;
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = '<span class="sp-price__now">' + SP.formatMoney(v.price) + '</span>' +
            (v.compare_at_price > v.price ? '<s class="sp-price__was">' + SP.formatMoney(v.compare_at_price) + '</s>' : '');
          priceEl.classList.toggle('is-sale', v.compare_at_price > v.price);
        }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : 'Sold out'; }
        if (v.featured_media) show(v.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-option-index] input', section).forEach(function (i) { i.addEventListener('change', update); });

      // Ajax add to cart
      if (form && $('.sp-drawer')) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
          Cart.add(new FormData(form)).catch(function (err) {
            alert((err && (err.description || err.message)) || 'Sorry, this item could not be added.');
          }).then(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label'); }
          });
        });
      }

      // Delivery estimate
      $$('[data-delivery]', section).forEach(function (el) {
        var min = Number(el.getAttribute('data-min')), max = Number(el.getAttribute('data-max'));
        function addBusiness(days) {
          var d = new Date();
          while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
          return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
        }
        var out = $('[data-delivery-range]', el);
        if (out) out.textContent = addBusiness(min) + ' – ' + addBusiness(max);
      });

      // Sticky add to cart
      var sticky = $('.sp-sticky-atc', section);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
        var sb = $('[data-sticky-add]', sticky);
        if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  /* ---------------- Collection filters ---------------- */
  function initFilters() {
    $$('[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="number"]')) return;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
      form.addEventListener('submit', function () {
        $$('input, select', form).forEach(function (i) { if (!i.value) i.disabled = true; });
      });
    });
    $$('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  onReady(function () {
    initIntro();
    fillArt(document);
    initHeader();
    initSnow();
    initCountdown();
    initRing();
    initParallax();
    initTilt(document);
    initReveal(document);
    initScrollers();
    Cart.init();
    initProduct();
    initFilters();
  });

  // Re-run for sections added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    fillArt(e.target); initTilt(e.target); initReveal(e.target);
    initSnow(); initCountdown(); initRing(); initParallax(); initScrollers();
  });
})();
